import PropTypes from "prop-types";

const GeneralModal = ({ isVisible, message, onClose, isSuccess }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="card w-full max-w-xs sm:max-w-sm md:max-w-md bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="card-body items-center text-center p-4 sm:p-6">
          <div className="flex items-center justify-center mb-3 sm:mb-4">
            <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full ${isSuccess ? 'bg-green-100' : 'bg-red-100'} flex items-center justify-center`}>
              {isSuccess ? (
                <i className="fa-solid fa-check text-2xl sm:text-3xl text-green-500"></i>
              ) : (
                <i className="fa-solid fa-xmark text-2xl sm:text-3xl text-red-500"></i>
              )}
            </div>
          </div>
          
          <h2 className="card-title text-gray-900 text-2xl sm:text-2xl font-bold mb-2 sm:mb-4">
            {isSuccess ? 'Success' : 'Error'}
          </h2>
          
          <p className="text-gray-600 text-sm sm:text-base whitespace-pre-wrap">
            {message}
          </p>
          
          <button 
            onClick={onClose}
            className={`px-4 sm:px-6 py-2 text-white rounded-lg mt-4 sm:mt-6 text-sm sm:text-base transition-colors ${
              isSuccess 
                ? 'bg-gray-800 hover:bg-gray-700'
                : 'bg-red-500 hover:bg-red-400'
            }`}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

GeneralModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  isSuccess: PropTypes.bool.isRequired,
};

export default GeneralModal;